import { css } from 'lit';

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: block;
	}

	og-dropdown {
		height: 100%;
	}

	div[slot="label"] {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	div[slot="label"] > span {
		margin-left: 5px;
		margin-right: 5px;
	}
`;

export const userMenuContentStyle = css`
	.usermenu-content {
		overflow: hidden;
		position: relative;
		min-width: 240px;
		max-width: 380px;
		height: 100%;
		padding: 8px 8px 4px;
	}
	.usermenu-content .user-header {
		width: 100%;
		display: flex;
		flex-direction: row;
		gap: 5px;
		align-items: center;
		padding-bottom: 8px;
		margin-bottom: 5px;
		border-bottom: 1px solid gray;
	}

	.usermenu-content og-button,
	.usermenu-content og-dropdown-menu {
		display: block;
		margin: 2px 5px;
	}
	.usermenu-content og-icon {
		margin-right: 5px;
	}
	.usermenu-content og-button.logout {
		color: var(--og-colortype-red-border-color);
	}
	.usermenu-content .switch {
		display: flex;
		margin: 2px 15px 2px 8px;
		align-items: center;
		justify-content: space-between;
	}
	.usermenu-content og-switch {
		--og-switch-width: 30px;
		--og-switch-height: 18px;
		height: 18px;
		width: 30px;
	}
`;
